import axios from 'axios'

export default class CommunicationApi {
    constructor(api) {
        this.$api = api
    }

    findMessage() {
        return axios({ url: '/communication/Message' })
    }

    postMessage(Message) {
        return axios({ url: '/communication/Message', method: 'post', data: Message })
    }

}



// WEBPACK FOOTER //
// ./src/api/CommunicationApi.js